import { classNames } from 'primereact/utils';
import { Control, Controller, FieldErrorsImpl } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from './NewTopologyForm';
import { useLazyCheckIfTopologyExistQuery } from '../../app/apiSlice';

export const NewTopologyTitle = ({control, errors}: {
    control: Control,
    errors: FieldErrorsImpl<FormFields>
}) => {

    const [checkIfTopologyExist, {data: topologyExist}] = useLazyCheckIfTopologyExistQuery();
    const {t} = useTranslation();

    return <div className="p-field mt-4">
        <span className="p-label">
            <label
                htmlFor="name"
                className={classNames({
                    'p-error': errors.name || topologyExist?.topologyExist,
                })}
                style={{fontWeight: 'bold'}}
            >{t('label.title')}*</label>
            <Controller
                name="name"
                control={control}
                rules={{
                    required: `${t('label.title')} ${t('label.required-m')}.`,
                }}
                render={({field, fieldState}) => (
                    <InputText
                        id={field.name}
                        {...field}
                        autoFocus
                        className={classNames({
                            'p-invalid':
                                fieldState.invalid || topologyExist?.topologyExist,
                        })}
                        onBlur={(e) =>
                            checkIfTopologyExist({name: e.target.value})
                        }
                        maxLength={128}
                    />
                )}
            />
        </span>
        {errors.name && <small className="p-error">{errors.name.message}</small>}
        {topologyExist?.topologyExist ? (
            <small className="p-error" style={{display: 'block'}}>
                Ce Titre existe déjà. Essayez un autre titre
            </small>
        ) : null}
    </div>
}

